export default __webpack_public_path__ + "static/media/cancel-icon.8d381f45.svg";